/* import __COLOCATED_TEMPLATE__ from './location-name-info-modal.hbs.js'; */
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Component from '@ember/component';
export default class LocationNameInfoModal extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    // Passed in from the modal service
    _defineProperty(this, "modalOptions", void 0);
    _defineProperty(this, "close", void 0);
    _defineProperty(this, "setCloseHandler", void 0);
  }
}